export enum CreativeItemType {
  Image = 'image',
  Video = 'video',
  Carousel = 'carousel',
  DynamicImage = 'dynamic_image',
  DynamicVideo = 'dynamic_video',
  Unknown = 'unknown',
}

export enum CreativeAssetType {
  Image = 'image',
  Video = 'video',
}

export interface CreativeAsset {
  id: string;
  type: CreativeAssetType;
  url: string | null;
  previewImageUrl: string;
}

export interface CreativeItem {
  creativeId: string;
  creativeName: string;
  adId: string;
  adName: string;
  accountId: string;
  sourceName: string;
  type: CreativeItemType;
  thumbnailUrl: string;
  videoPreviewUrl: string;
  assets: CreativeAsset[];
}

export interface MediaDimensionValue {
  ad_id: string;
  ad_name: string;
  media_source: string;
}

export function parseMediaDimensionValue(
  value: string,
): MediaDimensionValue | null {
  try {
    const parsed = JSON.parse(value);
    if (
      parsed &&
      typeof parsed.ad_id === 'string' &&
      typeof parsed.media_source === 'string'
    ) {
      return parsed as MediaDimensionValue;
    }
    return null;
  } catch {
    return null;
  }
}
